import { Component, OnDestroy, OnInit, ChangeDetectionStrategy,inject } from "@angular/core";
import { Router, RouterOutlet } from '@angular/router'; import { AuthService } from "./core/auth/auth.service";
import { HubManagerService } from "./shared/service/hub-manager-service";
import { UserStatusService } from "./shared/service/user-status.service";
import { RoomService } from "./shared/service/room.service";
import { CallService } from "./shared/service/call.service";
import { IncomingCallModalComponent } from "./features/messages/components/incoming-call-modal/incoming-call-modal.component";
import { distinctUntilChanged, map, Subscription } from "rxjs";
import { User } from "./shared/model/user";
import { HttpClient } from "@angular/common/http";
import { AsyncPipe } from "@angular/common";
import { ToastService } from "./shared/service/Toast/toast.service";
import { ToastComponent } from './shared/components/toast-component/toast-component';
import { Toast } from './shared/model/toast';
import { NotificationService } from './features/notifications/notification.service';
import { Notification, NotificationType } from './shared/model/notification';
import { LoadingOverlayComponent } from './shared/components/loading-overlay/loading-overlay.component'; 

@Component({
    selector: "app-root",
  templateUrl: "./app.component.html",
  imports: [
    LoadingOverlayComponent, RouterOutlet, ToastComponent, IncomingCallModalComponent, AsyncPipe
  ],

    changeDetection: ChangeDetectionStrategy.Default,
    styleUrls: ["./app.component.css"]
})
export class AppComponent implements OnInit, OnDestroy {
  tittle = "TopGun";
  user: User | undefined = undefined;
  toast?: Toast | undefined = undefined;

  private sub?: Subscription;
  private http = inject(HttpClient);

  notificationService = inject(NotificationService);
 constructor (
  private hubManagerService: HubManagerService,
   private authService: AuthService,
   private router: Router,
   public toastService: ToastService,
   private userStatusService: UserStatusService,
   private roomService: RoomService,
   public callService: CallService) { }


  ngOnInit(): void {
 
     this.authService.init().subscribe();

     this.sub = this.authService.getToken$()

    .pipe(
        map(t => !!t),
        distinctUntilChanged()
      )
      .subscribe(token => {
          if (token){
          this.hubManagerService.startAll().catch(() => {});
          this.roomService.startHub(this.authService.accessToken ?? '').catch(() => {});
          this.userStatusService.startIdleTracking();
        } else {
          this.hubManagerService.stopAll().catch(() => {});
        }
      });

      this.notificationService.on('NewMessageNotification', (notification: Notification) => {
      if (notification.type === NotificationType.FriendAccepted) {
        this.toast = {
          message: notification.text,
          type: 'success',
        };
          this.roomService.stopHub().catch(() => {});
      }
    });
  }
    ngOnDestroy (): void {
      this.sub?.unsubscribe();
    }
  }

